// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0af36c47] .v-data-table__mobile-row {\n  padding: 1rem !important;\n}", ""]);
// Exports
module.exports = exports;
